const mistakes = [
  {
    id: '01',
    title: 'Бросили «разбирайся сам»',
    problem: 'Самая распространённая ошибка. Новичку показывают стол и говорят: «Вникай». Результат — растерянность, ошибки, демотивация и увольнение.',
    solution: 'У каждого нового сотрудника должен быть наставник и план на первые недели с конкретными задачами.',
  },
  {
    id: '02',
    title: 'Нет наставника',
    problem: 'Назначить наставника — не значит поручить самому занятому сотруднику «присматривать». Без обученного наставника адаптация не работает.',
    solution: 'Выбрать наставника, обучить его методике, дать время и мотивацию для работы с новичком.',
  },
  {
    id: '03',
    title: 'Нет обучения',
    problem: 'Компания ждёт, что сотрудник всему научится «в бою». Но без обучения продукту, процессам и стандартам новичок обречён на ошибки.',
    solution: 'Программа обучения должна быть расписана по дням и неделям на весь испытательный срок.',
  },
  {
    id: '04',
    title: 'Слишком много информации сразу',
    problem: 'В первый день выдают стопку регламентов: «Изучай». Мозг не способен усвоить всё разом — через день сотрудник ничего не помнит.',
    solution: 'Информация подаётся дозированно: в первый день — самое важное, остальное — по мере необходимости в течение месяцев.',
  },
  {
    id: '05',
    title: 'Руководитель исчезает',
    problem: 'После найма руководитель «занят» и появляется раз в две недели. Без регулярного контакта адаптация не происходит.',
    solution: 'Запланировать регулярные встречи: ежедневно в первую неделю, еженедельно в первый месяц, раз в две недели далее.',
  },
  {
    id: '06',
    title: 'Нет оценки адаптации',
    problem: 'Никто не проверяет, как идёт процесс. Руководитель узнаёт о проблемах, когда сотрудник уже пишет заявление об уходе.',
    solution: 'Контрольные точки: конец первой недели, первого месяца, второго месяца. Промежуточная и финальная оценка.',
  },
  {
    id: '07',
    title: 'Нет обратной связи',
    problem: 'Новичок не знает, хорошо ли он справляется. Отсутствие фидбэка порождает тревогу и снижает мотивацию.',
    solution: 'Обратная связь должна быть регулярной: что получается, что улучшить, какие следующие шаги.',
  },
  {
    id: '08',
    title: 'Отсутствуют стандарты',
    problem: 'Каждый руководитель адаптирует «как умеет». В одном отделе новичок стартует за 2 недели, в другом — тонет полгода.',
    solution: 'Единая программа адаптации персонала с чек-листами, стандартами и регламентами для всей компании.',
  },
];

export default function MainMistakes() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Главные ошибки компаний в адаптации сотрудников
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Большинство компаний теряют новых сотрудников не из-за зарплаты, а из-за этих восьми критических ошибок. Каждую можно исправить — если знать как.
        </p>

        <div className="space-y-8">
          {mistakes.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-6 md:p-8 border border-gray-200">
              <div className="flex flex-col md:flex-row gap-4 md:gap-8 items-start">
                <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-xl">{item.id}</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                  <div className="grid md:grid-cols-2 gap-4 md:gap-8 mt-4">
                    <div className="bg-red-50 rounded-lg p-4 border border-red-100">
                      <span className="text-sm font-semibold text-red-700 flex items-center gap-1 mb-1">
                        <i className="ri-close-circle-line"></i> Ошибка
                      </span>
                      <p className="text-gray-700 text-sm leading-relaxed">{item.problem}</p>
                    </div>
                    <div className="bg-teal-50 rounded-lg p-4 border border-teal-100">
                      <span className="text-sm font-semibold text-teal-700 flex items-center gap-1 mb-1">
                        <i className="ri-checkbox-circle-line"></i> Решение
                      </span>
                      <p className="text-gray-700 text-sm leading-relaxed">{item.solution}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}